import { create } from 'zustand'

export type ToastType = 'success' | 'error' | 'info'

export interface Toast {
  id: string
  message: string
  type: ToastType
  isVisible: boolean
}

interface ToastState {
  toast: Toast | null
  showToast: (message: string, type?: ToastType) => void
  hideToast: () => void
  clearToast: () => void
}

export const useToastStore = create<ToastState>(set => ({
  toast: null,

  showToast: (message: string, type: ToastType = 'info') => {
    const id = Date.now().toString()

    // 기존 토스트가 있으면 즉시 제거
    set({ toast: null })

    // 새로운 토스트 표시
    setTimeout(() => {
      set({
        toast: {
          id,
          message,
          type,
          isVisible: true,
        },
      })
    }, 10)

    // 3초 후 자동으로 숨기기 (2초 표시 + 0.5초 페이드 아웃 + 0.5초 여유)
    setTimeout(() => {
      set(state => {
        if (state.toast?.id === id) {
          return {
            toast: {
              ...state.toast,
              isVisible: false,
            },
          }
        }
        return state
      })
    }, 2000)

    // 페이드 아웃 애니메이션 완료 후 완전히 제거
    setTimeout(() => {
      set(state => {
        if (state.toast?.id === id) {
          return { toast: null }
        }
        return state
      })
    }, 2500)
  },

  hideToast: () => {
    set(state => {
      if (state.toast) {
        return {
          toast: {
            ...state.toast,
            isVisible: false,
          },
        }
      }
      return state
    })

    // 페이드 아웃 애니메이션 완료 후 제거
    setTimeout(() => {
      set({ toast: null })
    }, 500)
  },

  clearToast: () => {
    set({ toast: null })
  },
}))
